import './PageContainer.scss';

import { Layout } from 'antd';
import type { ApiError } from 'common/models';
import QueryErrorAlert from 'components/ErrorAlert/QueryErrorAlert';
import Helmet from 'components/Helmet/Helmet';
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator';
import type { PropsWithChildren } from 'react';
import React from 'react';

import type { PageHeaderDefinition } from './PageToolbar';
import PageToolbar from './PageToolbar';

interface Props {
  pageTitle: string;
  header?: PageHeaderDefinition;
  className?: string;
  isLoading?: boolean;
  error?: ApiError | null;
  onRetry?: () => void;
}

const PageContainer: React.FC<PropsWithChildren<Props>> = (props): React.ReactElement => {
  const { pageTitle, header, children, className, isLoading, error, onRetry } = props;

  return (
    <>
      <Helmet title={pageTitle} />
      <Layout className={`PageContainer ${className}`}>
        {header && <PageToolbar {...header} />}
        {error && <QueryErrorAlert error={error} onRetry={onRetry} />}
        {isLoading ? <LoadingIndicator /> : children}
      </Layout>
    </>
  );
};

export default PageContainer;
